import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { HiCalendar } from 'react-icons/hi'
import { useLocalizedLink } from '../../hooks/useLocalizedLink'
import { getLocalizedNews } from '../../data/newsData'
import SEO from '../../components/SEO/SEO'
import { seoBreadcrumbPair } from '../../utils/seoUtils'
import './News.css'

function News() {
  const { t, i18n } = useTranslation()
  const getLocalizedLink = useLocalizedLink()

  // Новости (отсортированы по дате, новые первыми)
  const newsItems = getLocalizedNews(i18n.language)

  const breadcrumbItems = useMemo(
    () => seoBreadcrumbPair(t('common.home'), t('common.news'), 'news'),
    [t]
  )

  return (
    <div className="news-page">
      <SEO 
        title={t('common.news')}
        description={t('news.description', 'Latest news from SUMA International')}
        breadcrumbItems={breadcrumbItems}
      />
      <div className="container">
        <div className="news-hero">
          <h1>{t('common.news')}</h1>
          <p className="news-intro">
            {t('news.intro', 'Stay informed with the latest news, updates, and announcements from SUMA International and the martial arts community.')}
          </p>
        </div>

        <div className="news-list">
          {newsItems.length > 0 ? (
            newsItems.map(item => (
              <article key={item.id} className="news-card">
                {item.image && (
                  <div className="news-image-wrapper">
                    <img 
                      src={item.image} 
                      alt={item.title}
                      className="news-image"
                      loading="lazy"
                    />
                  </div>
                )}
                <div className="news-card-content">
                  <div className="news-date">
                    <HiCalendar className="date-icon" />
                    <span>{item.date}</span>
                  </div>
                  <h2>{item.title}</h2>
                  <p className="news-excerpt">{item.preview}</p>
                  <Link to={`${getLocalizedLink('/news')}/${item.id}`} className="news-link">
                    {t('news.readMore', 'Read more')} →
                  </Link>
                </div>
              </article>
            ))
          ) : (
            <div className="no-news">
              <p>{t('news.noNews', 'News articles will be displayed here as they are published.')}</p>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default News
